// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tfr6","newExpiryDate":"styles_newExpiryDate__2fYCJ","footer":"styles_footer__2Uwvr"};